import axios from "axios";
import { getCookies } from "../utils/Helpers";
import { setCookies } from "../utils/Helpers";
class APIService {
  constructor() {
    this.service = axios.create({
      baseURL: process.env.REACT_APP_BASE_URL,
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: false,
    });
  }

  // Method to update the token in the headers
  updateAuthToken() {
    const token = getCookies("adminToken");
    if (token) {
      this.service.defaults.headers.common["x-auth-token"] = token;
    }
  }

  // Call this method before making any requests
  async makeRequest(method, path, payload, headers) {
    this.updateAuthToken(); // Ensure the token is up-to-date
    const config = { headers };
    // Axios expects "data" inside config for DELETE
    if (method === "delete" && payload) {
      config.data = payload;
      return this.retryRequest(
        this.service[method].bind(this.service),
        path,
        config
      );
    }

    return this.retryRequest(
      this.service[method].bind(this.service),
      path,
      payload,
      { headers }
    );
  }

  async retryRequest(requestFunction, path, payload, headers) {
    let retries = 3;

    while (retries > 0) {
      try {
        const response = await requestFunction(path, payload, headers);
        // Add status to the response data
        response.data.status = response.status;
        return response.data;
      } catch (error) {
        if (error.response) {
          if (error.response.status >= 500) {
            retries--;

            if (retries === 0) {
              return this.handleErrorResponse(error);
            } else {
              await new Promise((resolve) => setTimeout(resolve, 1000));
            }
          } else {
            if (error.response.status === 401) {
              setCookies("adminToken", null);
              window.location.href = "#/login";
            }
            return error.response;
          }
        } else {
          return this.handleErrorResponse(error);
        }
      }
    }
  }

  async get(path, config) {
    return this.makeRequest("get", path, config);
  }

  async patch(path, payload) {
    return this.makeRequest("patch", path, payload);
  }

  async post(path, payload, headers = { "content-type": "application/json" }) {
    return this.makeRequest("post", path, payload, headers);
  }

  async put(path, payload, headers = { "content-type": "application/json" }) {
    return this.makeRequest("put", path, payload, headers);
  }

  async delete(
    path,
    payload,
    headers = { "content-type": "application/json" }
  ) {
    console.log("path, payload", path, payload);

    return this.makeRequest("delete", path, payload, headers);
  }

  handleErrorResponse(error) {
    console.log(error?.response?.status);

    if (error?.response?.status == 401) {
      setCookies("adminToken", null);
    }
    if (error && error.response) {
      const { status, data } = error.response;
      console.error("Error response:", { status, data });
      return error.response;
    } else {
      console.error("Something went wrong!");
      return { status: 500, data: { message: "Something went wrong!" } };
    }
  }

  async eventSourcePost(
    path,
    payload,
    headers = { "Content-Type": "application/json" }
  ) {
    const url = `${process.env.REACT_APP_API_URL}${path}`;
    const token = getCookies("adminToken");
    const eventSource = new EventSource(url, {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": token,
        ...headers,
      },
    });
    console.log("eventSource ", eventSource);
    return eventSource;
  }
}

export default new APIService();
